<template>
  <div>
    <!-- Navigation Drawer (Sidebar) -->
    <v-navigation-drawer v-model="sidebarVisible" app temporary dark>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="text-h6">
            Menú de navegación
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list nav dense active-class="white--text">
        <v-list-group prepend-icon="mdi-account-group" no-action value="true" active-class="white--text">
          <template v-slot:activator>
            <v-list-item-title>Inscripción</v-list-item-title>
          </template>
          <v-list-item @click="navigate('/dashboard')" active-class="white--text">
            <v-list-item-title>Inicio</v-list-item-title>
          </v-list-item>
          <v-list-item @click="navigate('/inscripciones')" active-class="white--text">
            <v-list-item-title>Cargadores</v-list-item-title>
          </v-list-item>
          <v-list-item @click="navigate('/inscribir')" active-class="white--text">
            <v-list-item-title>Inscribir</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group prepend-icon="mdi-calendar-clock" no-action active-class="white--text">
          <template v-slot:activator>
            <v-list-item-title>Turnos</v-list-item-title>
          </template>
          <v-list-item @click="navigate('/turnos')" active-class="white--text">
            <v-list-item-title>Asignación de turnos</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group prepend-icon="mdi-cog" no-action active-class="white--text">
          <template v-slot:activator>
            <v-list-item-title>Administración</v-list-item-title>
          </template>
          <v-list-item @click="navigate('/procesiones')" active-class="white--text">
            <v-list-item-title>Procesiones</v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>

    <!-- App Bar (Top Navigation) -->
    <v-app-bar app color="dark" dark>
      <v-app-bar-nav-icon @click.stop="sidebarVisible = !sidebarVisible"></v-app-bar-nav-icon>

      <v-spacer></v-spacer>

      <v-btn text @click="activaDialogProc()">
        <v-icon left>mdi-arrow-down-drop-circle</v-icon>
        <span class="d-none d-sm-flex">{{ procesion }}</span>
      </v-btn>

      <v-btn text @click="logout()">
        <v-icon left>mdi-logout</v-icon>
        Cerrar Sesión
      </v-btn>
    </v-app-bar>

    <!-- Dialog for Processions -->
    <v-dialog v-model="dialogProcesion" max-width="500px" persistent>
      <v-card>
        <v-card-title class="text-h5">Selecciona la procesión que deseas gestionar</v-card-title>
        <v-card-text>
          <v-combobox v-model="selectedProcesion" :items="procesiones" label="Selecciona una procesión"
            item-text="label" item-value="ID_Procesion"></v-combobox>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="cancel" v-if="procesion">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="setProcesion" :disabled="!selectedProcesion">Hecho</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { EventBus } from "@/utils/eventBus";

export default {
  data() {
    return {
      sidebarVisible: false, // Controla la visibilidad del sidebar
      dialogProcesion: false,
      procesiones: [],
      selectedProcesion: null,
      procesion: "",
    };
  },
  mounted: function () {
    if (this.$cookies.get("ProcesionID") == null) {
      this.obtieneProcesiones();
    }

    this.procesion = this.$cookies.get("Procesion");
  },
  methods: {
    setProcesion() {
      if (!this.selectedProcesion) return;
      // Guardar el ID de la procesión seleccionada en una cookie
      const selectedProcesionId = this.selectedProcesion.ID_Procesion;
      const selectedProcesionDesc = this.selectedProcesion.Descripcion;
      const selectedProcesionCostoCargador = this.selectedProcesion.Costo_Inscripcion;
      const selectedProcesionCostoAspirante = this.selectedProcesion.Costo_Aspirante;
      const selectedProcesionCostoS = this.selectedProcesion.Costo_honors;
      const selectedProcesionCostoE = this.selectedProcesion.Costo_honore;
      if (selectedProcesionId !== null) {
        this.$cookies.set("ProcesionID", selectedProcesionId); // Guarda el ID en una cookie
        this.$cookies.set("Procesion", selectedProcesionDesc); // Guarda el ID en una cookie
        this.$cookies.set("ProcesionCost", selectedProcesionCostoCargador);
        this.$cookies.set("ProcesionACosto", selectedProcesionCostoAspirante);
        this.$cookies.set("ProcesionSCost", selectedProcesionCostoS);
        this.$cookies.set("ProcesionECost", selectedProcesionCostoE);
        this.dialogProcesion = false; // Cerrar el diálogo después de guardar
        this.procesion = selectedProcesionDesc;

        // Redirigir a /dashboard si no está en esa ruta
        if (this.$route.path !== "/dashboard") {
          this.$router.push("/dashboard").then(() => {
            // Emitir evento después de redirigir
          });
        } else {
          // Emitir evento directamente si ya está en /dashboard
          EventBus.$emit("procesionChanged");
        }
      }
    },

    async obtieneProcesiones() {
      // Verificar cookies en un bucle hasta que tengan un valor
      while (!this.$cookies.get("username") || !this.$cookies.get("token")) {
        await new Promise((resolve) => setTimeout(resolve, 1000)); // Esperar 1 segundo antes de volver a intentar
      }

      const apiUrl = `https://hk32hsqoo6.execute-api.us-east-1.amazonaws.com/dev/api/procesiones?usuarioResponsable=${this.$cookies.get("username")}&incluirDesactivadas=false`;
      const token = this.$cookies.get("token");
      // Configuración para la solicitud GET con el token en el encabezado Authorization
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      // this.loading = true; // Activar animación de carga
      // Realizar solicitud GET a la API original con el token en el encabezado
      axios
        .get(apiUrl, config)
        .then((response) => {
          if (response.data?.records?.length > 0) {
            this.procesiones = response.data.records.map((procesion) => ({
              ...procesion,
              label: `${procesion.Descripcion} - ${procesion.Fecha}`, // Concatenar Descripcion y Fecha
            }));
            this.dialogProcesion = true; // Mostrar el diálogo después de cargar las procesiones
          } else {
            this.loading = false
            // Evitar redirigir si ya estamos en la página de '/procesiones'
            if (this.$route.path !== "/procesiones") {
              this.$router.push("/procesiones"); // Redirigir si no hay datos
            }
          }

        })
        .catch(() => {
          // console.error("Error al obtener datos de la API", error);
          // this.loading = false; // Desactivar animación de carga en caso de error
        });
    },
    cancel() {
      this.dialogProcesion = false;
    },
    activaDialogProc() {
      this.obtieneProcesiones();
      this.dialogProcesion = true;
    },
    navigate(route) {
      this.sidebarVisible = false; // Oculta el sidebar al navegar
      // Verificar si la ruta actual es diferente de la ruta a la que se quiere navegar
      if (this.$route.path !== route) {

        this.$router.push(route); // Redirige a la ruta deseada
      }
    },
    logout() {
      this.clearAllCookies();
      this.$router.push("/");
    },
    clearAllCookies() {
      const allCookies = this.$cookies.keys();
      for (const cookie of allCookies) {
        this.$cookies.remove(cookie);
      }
    },
  },
};
</script>

<style scoped>
</style>
